.goldProgressContainer {
  padding-bottom: 0;
  border-top: 1px solid var(--colors-grays-light);
}

.productRow {
  display: flex;
  align-items: center;
  width: 100%;
  margin-bottom: 16px;
}

.productRow:last-child {
  margin-bottom: 0;
}

.unlockedContainer {
  border-top: 1px solid var(--colors-grays-light);
  padding-top: 24px;
}

.productInfo {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
  min-width: 0; /* Needed for text truncation to work */
}

.productImage {
  flex-shrink: 0;
  border-radius: 8px;
  border: 1px solid var(--colors-grays-light);
}

.productName {
  flex: 1;
  min-width: 0; /* Needed for text truncation to work */
}

.removeButton {
  color: var(--colors-grays-mid);
  cursor: pointer;
}

.icon__xs {
  width: 14px;
  height: 14px;
}

.tagContainer {
  flex-shrink: 0;
  margin-left: 12px;
}
